var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _text, _text2, _text3, _text4, _path9, _path0, _path1, _path10, _path11, _text5, _text6, _text7, _text8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-gu",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#be0027",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#3b5aa3",
    d: "M20.48 20.48h470v471.04h-470z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M251.86 396.13c1.818.996 4.694.943 6.312.078 103.36-54.986 103.42-205.78.15-259.99-1.918-1.01-4.706-.956-6.613.08-100.72 55.104-100.99 204.19.15 259.84z",
    fillRule: "evenodd",
    fill: "#cbe0e5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M251.86 398.85c1.607 1.31 4.847 1.184 6.312.078 76.168-57.026 76.615-92.573 73.24-92.572l-150.75.08c-2.306 0 1.327 36.085 71.198 92.413z",
    fillRule: "evenodd",
    fill: "#add2d9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192.6 334.61c6.536-1.7 14.43-2.15 20.863 1.286 5.715 2.986 9.026 2.957 15.183 3.04 6.444.086 11.51 4.82 18.478 5.006 12.83.336 18.235 6.698 8.26 6.71-4.715.008-14.822-3.142-19.7-2.465-10.19 1.052-16.658 3.308-26.25 13.976l11.086 7.596c9.588-3.91 11.195-8.305 16.504-8.48 5.998-.193 8.036-3.91 14.972-3.918 7.88 1.432 18.555-.978 24.807-2.38 11.09-2.577 5.814-10.327-.908-13.137-5.434-2.313-15.61-.085-21.927-2.38-4.782-1.856-.847-4.842 1.72-5.48 2.596-.477 5.38.37 8.607.89 5.762.5 13-.055 18.058-.848 10.46-1.62 10.02-4.687 15.07-4.77 3.683-.176 6.486-1.277 8.995-3.08 2.95-1.974 6.016-6.02 9.59-5.868l9.568.405-13.477 30.31-38.074 38.752-19.718 7.48-43.342-28.216-21.856-33.522 3.49-.907z",
    fillRule: "evenodd",
    fill: "#fdf9a1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M242.41 305.14l87.027-.405 1.53-7.71s-3.105-.465-5.61-.61c-3.124-.193-8.48 3.267-12.068 3.246-2.54-.017-5.447-4.56-7.988-4.465-4.435-.04-4.83 3.95-9.01 4.06-3.373-.115-4.81-2.69-9.178-2.435-4.58.26-4.24 2.78-10.027 2.637-7.643-.192-10.713-6.824-16.828-6.9-10.208-.12-10.54 9.742-17.85 12.582z",
    fillRule: "evenodd",
    fill: "#179a3b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M242.41 307l89.576-.456v-2.434l-91.614.456L242.41 307z",
    fillRule: "evenodd",
    fill: "#fdf9a1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M279.22 333.92c1.38 5.29 2.834 7.09 8.398 8.437 5.496 1.352 13.88-4.006 8.67-9.178-4.962-4.813-10.175-6.035-14.62-10.37-9.352-9.24-23.445-31.88-23.458-47.848-.01-13.712-1.333-41.855-1.343-68.51.007-1.728-5.21 4.842-5.2 6.597.24 23.515.203 41.288 1.158 65 1.48 17.335 9.753 29.007 17.016 39.542 3.255 5.048 7.958 10.492 9.38 16.328z",
    fillRule: "evenodd",
    fill: "#a79270"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontFamily: "helvetica",
    fontSize: 25.614,
    stroke: "#fff",
    y: 269.487,
    x: 465.114,
    strokeWidth: 1.638,
    fill: "#bd0728",
    transform: "translate(-256.29 5.09)"
  }, /*#__PURE__*/React.createElement("tspan", null, "G"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "helvetica",
    fontSize: 25.614,
    stroke: "#fff",
    y: 269.607,
    x: 488.065,
    strokeWidth: 1.638,
    fill: "#bd0728",
    transform: "translate(-256.29 5.09)"
  }, /*#__PURE__*/React.createElement("tspan", null, "U"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "helvetica",
    fontSize: 25.614,
    stroke: "#fff",
    y: 269.59,
    x: 516.053,
    strokeWidth: 1.638,
    fill: "#bd0728",
    transform: "translate(-256.29 5.09)"
  }, /*#__PURE__*/React.createElement("tspan", null, "A"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "helvetica",
    fontSize: 25.614,
    stroke: "#fff",
    y: 269.542,
    x: 539.532,
    strokeWidth: 1.638,
    fill: "#bd0728",
    transform: "translate(-256.29 5.09)"
  }, /*#__PURE__*/React.createElement("tspan", null, "M"))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M211.9 207.31c-1.158 2.235 2.712-.652 3.588-.963 5.015-1.785 6.98-8.12 15.62-4.306 6.8 2.94 15.93 1.23 11.157 4.207-5.897 3.53-17.64 7.44-17.872 24.945.98 1.712 1.052 1.442 1.873-.393 1.784-4.08 10.296-15.16 14.508-14.24 1.695.44 6.675-5.006 6.79-3.452.452 4.372-6.76 13.214-6.684 25.05.018 2.742 3.39 3.63 5.015 1.702 1.616-1.7 2.525-3.46 5.355-5.693 5.002-4.104 3.62-21.51 4.238-20.693 3.54 4.584 4.085 17.513 9.36 22.816 4.38 4.407 7.925 2.297 6.968-3.824-1.903-12.27-7.703-8.762-10.464-21.453-.56-2.473-.697-4.706 2.574-3.672 4 1.16 6.35 3.02 9.334 7.533 2.984 4.304 8.58 8.43 11.813 10.963 5.64 4.335 7.622.55 4.93-5.014-2.98-6.242-9.697-11.418-15.807-13.682-4.628-1.6-6.278-1.75-10.356-2.534-1.133-.24-2.305-2.563-.29-3.846 4.32-2.64 9.487-5.62 14.726-5.772 5.045-.127 9.04 3.916 12.578 4.93 7.055 1.848 7.02-2.63 3.91-5.95-2.555-2.805-7.958-7.508-13.002-6.883-10.178 1.248-9.536.963-15.78 5.105-2.29 1.35-4.833 2.84-3.884 1.203 2.284-4.11.156-3.403 3.685-7.585 2.744-3.063 4.76-5.27 7.48-6.034 2.583-.622 5.996-3.367 7.052-4.76 2.535-3.506.35-5.508-3.568-4.333-3.4.936-5.228 3.2-7.565 3.825-5.482 1.727-9.905 14.27-10.58 16.046-.874 2.123-1.84 1.07-1.662-.727.792-8.855 1.54-23.682-1.587-29.786-4.708-9-4.272-4.803-6.08-.532-2.72 6.785-1.775 13.11-.06 19.76.748 3.318 3.528 7.095 4.026 9.7.358 2.046-1.19-.637-2.088-1.865-2.956-4.523-5.117-7.582-9.93-10.045-3.29-2.082-12.148-2.362-15.232-1.413-1.335.41 1.48 2.316 2.674 3.263 3.228 2.566 9.344 3.366 13.46 5.895 3.533 2.173 6.224 3.57 7.395 6.574.487 2.23 1.21 5.54-.258 5.46-3.855-.222-9.847-3.558-22.148-2.187-6.282.83-11.736 6.205-15.213 12.663z",
    fillRule: "evenodd",
    fill: "#239e46"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M238.71 319.84h3.57v5.95h-3.57z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M220.99 280.21c14.154 19.6 36.84 31.025 37.295 39.926-14.334-.057-29.87.007-44.206-.05 10.155-12.21 16.345-20.454 6.91-39.876z",
    fillRule: "evenodd",
    fill: "#fdf9ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M208.12 320.58c19.23 4.288 42.187 6.65 56.85-.6.12 4.286-4.767 10.456-8.774 10.456h-36.898c4.286-.614 6.73-1.92 13.704-2.284l-19.59.24c-2.165.082-6.012-5.73-5.29-7.812z",
    fillRule: "evenodd",
    fill: "#a68861"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M251.73 405.93c1.955 1.07 5.045 1.014 6.785.085 111.1-59.135 111.16-221.3.162-279.61-2.063-1.087-5.06-1.028-7.11.085-108.26 59.262-108.55 219.59.163 279.44zm.552-13.35c1.707.945 4.404.896 5.923.074 92.997-54.73 94.136-199.32.14-251.15-1.798-1.322-4.415-.908-6.204.074-89.066 52.672-94.033 191.3.142 251z",
    fillRule: "evenodd",
    fill: "#be0027"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25.614,
    y: 269.487,
    x: 465.114,
    fontFamily: "helvetica",
    fill: "#bd0728",
    transform: "translate(-256.29 5.09)"
  }, /*#__PURE__*/React.createElement("tspan", null, "G"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25.614,
    y: 269.607,
    x: 488.065,
    fontFamily: "helvetica",
    fill: "#bd0728",
    transform: "translate(-256.29 5.09)"
  }, /*#__PURE__*/React.createElement("tspan", null, "U"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25.614,
    y: 269.59,
    x: 516.053,
    fontFamily: "helvetica",
    fill: "#bd0728",
    transform: "translate(-256.29 5.09)"
  }, /*#__PURE__*/React.createElement("tspan", null, "A"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    fontSize: 25.614,
    y: 269.542,
    x: 539.532,
    fontFamily: "helvetica",
    fill: "#bd0728",
    transform: "translate(-256.29 5.09)"
  }, /*#__PURE__*/React.createElement("tspan", null, "M"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGu);
export default __webpack_public_path__ + "static/media/gu.b0009474885a729f6e039fbba4150cbd.svg";
export { ForwardRef as ReactComponent };